import { gql } from '@apollo/client';

export const GET_DASHBOARD_REPORT_FILE_LISTING = gql`
    query DashboardReportQuery(
        $filters: ReportFileFiltersTypeInput
        $pageRequest: PageRequestTypeInput
    ) {
        getDashboardReportFileListing(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                type
                name
                reportDate
                status
                operatorId
                operatorName
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface DashboardReportListResponse {
    getDashboardReportFileListing: DashboardReportFileListingResponseType;
}

export interface DashboardReportFileListingResponseType {
    content: DashboardReportFileType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface DashboardReportFileType {
    id: string;
    type: number;
    name: string;
    reportDate: string;
    status: number;
    operatorId?: string;
    operatorName?: string;
}
